"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bione": {
    "2781b828": [{
      "hkey": "9cf46989",
      "slug": "bione",
      "name": "Bione",
      "primary": true,
      "skipSearch": false
    }],
    "bersenico-sopra": [{
      "hkey": "9cf46989",
      "slug": "bione",
      "name": "Bione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "34ff273e": [{
      "hkey": "9cf46989",
      "slug": "bione",
      "name": "Bione",
      "primary": true,
      "skipSearch": false
    }],
    "bersenico-sotto": [{
      "hkey": "9cf46989",
      "slug": "bione",
      "name": "Bione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "62b67bfb": [{
      "hkey": "9cf46989",
      "slug": "bione",
      "name": "Bione",
      "primary": true,
      "skipSearch": false
    }],
    "casa-dei-fondi": [{
      "hkey": "9cf46989",
      "slug": "bione",
      "name": "Bione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "15a06f88": [{
      "hkey": "9cf46989",
      "slug": "bione",
      "name": "Bione",
      "primary": true,
      "skipSearch": false
    }],
    "casa-dei-santi": [{
      "hkey": "9cf46989",
      "slug": "bione",
      "name": "Bione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2dc6b9b1": [{
      "hkey": "9cf46989",
      "slug": "bione",
      "name": "Bione",
      "primary": true,
      "skipSearch": false
    }],
    "marcherane": [{
      "hkey": "9cf46989",
      "slug": "bione",
      "name": "Bione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;